module.exports = __webpack_public_path__ + "static/cfrdevsummit-b55916b05eac299778bd073ac98f8059.png";